import React, { useEffect, useState, useMemo, useRef } from "react";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Form,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
import { DatePicker, Switch, message } from "antd";
import moment from "moment";
// import "../style.css";
import actionCreators from "store/actionCreators/campaign";
import leftIcon from "../../../../assets/icons/angle-left-solid-full.svg";
import noImage from "assets/img/noImage.png";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import editorConfig from "../../../../utils/textEditorConfig";

import { connect } from "react-redux";
import AvatarEditor from "views/Components/AvatarEditor";
const CanOptions = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

function EditCampaign(props) {
  const [tagsList, setTagList] = useState([]);
  const [item, setItem] = useState(null);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userLimit, setUserLimit] = useState(null);
  const [userLimitError, setUserLimitError] = useState(null);
  const [campaignTitle, setCampaignTitle] = useState("");
  const [campaignTitleError, setCampaignTitleError] = useState(null);
  const [campaignName, setCampaignName] = useState("");
  const [campaignNameError, setCampaignNameError] = useState(null);
  // const makingCopy = new URLSearchParams(location.search).get("copy");
  const [imgId, setImgId] = useState(null);
  const [imgUrl, setImgUrl] = useState(null);
  const [createUserGroup, setCreateUserGroup] = useState(false);

  const checkvalidOfferTitle = (value) => {
    if (!value) {
      setCampaignTitleError("OfferTitle is required");
    } else {
      setCampaignTitleError(null);
    }
  };

  const checkvalidCampaignName = (value) => {
    if (!value) {
      setCampaignNameError("Campaign Name is required");
    } else {
      setCampaignNameError(null);
    }
  };

  let saveWhitePreview = (preview) => {
    if (preview) {
      let file = new File([preview.blob], "1.png", { type: "image/png" });
      var formData = new FormData();
      formData.append("File", file);
      formData.append("ImageType", "partnerCampaigns");
      props.uploadImage(formData).then((res) => {
        setImgId(res.id);
        setImgUrl(res.url);
      });
    }
  };

  useEffect(() => {
    getItem();
  }, []);
  const getItem = () => {
    console.log(props.item);
    props.getCampaignById(props.item.id).then((res) => {
      setItem(res);
      setStartDate(moment(res.startDate));
      setEndDate(moment(res.endDate));
      setUserLimit(res.userLimit);
      toDraft(res.description);
      setDescription(res.description);
      setCampaignTitle(res.title);
      setCampaignName(res.name);
      setImgId(res.campaignImage);
      setImgUrl(res.campaignImagePresignedUrl);
      setCreateUserGroup(res.createUserGroup);
      // setTagList(interests);
    });
  };
  const approveButton = () => {
    props.onApprove();
  };

  const checkvalidUserLimit = (value) => {
    if (!value) {
      setUserLimitError("User Limit is required");
    } else if (value.match(/^[0-9]+$/) == null) {
      setUserLimitError(
        "Please enter the user limit value only in numerical format",
      );
    } else if (value < 0) {
      setUserLimitError("Please enter a value greater than 0");
    } else {
      setUserLimitError(null);
    }
  };

  const disableStartDate = (current) => {
    if (!current) {
      return false;
    }

    const isPastDate = current.isBefore(moment().subtract(1, "day"), "day");
    const isAfterEndDate = endDate ? current.isAfter(endDate, "day") : false;

    return isPastDate || isAfterEndDate;
  };

  const disableEndDate = (current) => {
    if (!current) {
      return false;
    }

    const isPastDate = current.isBefore(moment().subtract(1, "day"), "day");
    const isBeforeStartDate = startDate
      ? current.isBefore(startDate, "day")
      : false;

    return isPastDate || isBeforeStartDate;
  };

  const continueClick = () => {
    // if (campaignTitle == "") {
    //   setCampaignTitleError("Campaign Title is required");
    //   message.error("Campaign Title is required");
    //   return;
    // }

    // if (!loginStatus) return;

    if (startDate && endDate && startDate.isAfter(endDate, "day")) {
      message.error("Start Date cannot be later than End Date");
      return;
    }

    let obj = {
      name: campaignName,
      title: campaignTitle,
      description: description ?? null,
      // campaignImage: imgId,
      startDate: startDate ? startDate.format("YYYY-MM-DD HH:mm:ss") : null,
      endDate: endDate ? endDate.format("YYYY-MM-DD HH:mm:ss") : null,
      userLimit: userLimit && userLimit > 0 ? userLimit : null,
      // qualifyingPurchaseId: selectedPurchase?.id,
      // offerId: selectedOffer?.id,
      createUserGroup: createUserGroup,
    };

    obj.campaignImage = imgId ?? null;
    obj.campaignId = props.item.id;
    props.updateCampaignById(obj).then((res) => {
      // if (res) {
      //   setModalShow(true);
      // }
    });
  };

  const backButton = () => {
    props.setPage("1");
  };
  console.log(item);

  const toDraft = (value) => {
    const blocksFromHtml = htmlToDraft(value);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap,
    );
    const editorState = EditorState.createWithContent(contentState);
    setEditorState(editorState);
  };

  const toHtml = (value) => {
    let templateContent = draftToHtml(convertToRaw(value.getCurrentContent()));
    setDescription(templateContent);
  };
  const handleBeforeInput = (chars) => {
    const totalLength =
      editorState.getCurrentContent().getPlainText().length + chars.length;
    return totalLength > 2000;
  };

  const onEditorStateChange = (editorNewState) => {
    const contentState = editorNewState.getCurrentContent();
    toHtml(editorNewState);
    setEditorState(editorNewState);
    if (contentState.getPlainText().length <= 2000) {
      setDescriptionError(null);
    } else {
      setDescriptionError("Description must not exceed 2000 characters");
    }
  };

  const styles = {
    editor: {
      border: "1px solid #eef0f4",
      minHeight: "200px",
      padding: "10px",
    },
  };

  const focusEditor = () => {
    // if (setEditor.current) {
    //     setEditor.current.focus();
    // }
  };

  return (
    <>
      {item && (
        <div className="content paybill">
          <div onClick={backButton} className="back-button-title mb-2">
            <img className="mb-1" width="14px" src={leftIcon} />
            Back
          </div>
          <Row>
            <Col md="7">
              <Card>
                <CardHeader className="paybill-header">
                  <h5 className="title ml-2">Campaign Details</h5>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Campaign Name</label>
                          <Input
                            placeholder="Campaign Name"
                            type="text"
                            value={campaignName}
                            onChange={(event) => {
                              setCampaignName(event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Campaign Title</label>
                          <Input
                            placeholder="Campaign Title"
                            type="text"
                            value={campaignTitle}
                            onChange={(event) => {
                              setCampaignTitle(event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col className="pr-1" md="6">
                        {/* <div>
                          {" "}
                          <label>Cover Image</label>
                        </div> */}
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="mb-0">Campaign Image</label>
                          <Button
                            onClick={() => {
                              setImgId(null);
                              setImgUrl(null);
                            }}
                            color="secondary"
                            size="md"
                            className="btn-round cancel-button"
                            style={{ padding: "6px 12px" }}
                          >
                            Remove Image{" "}
                          </Button>
                        </div>

                        <div
                          style={{ maxWidth: "785px", marginBottom: "20px" }}
                        >
                          <AvatarEditor
                            show={true}
                            big
                            keys="white"
                            title="Upload Campaign Cover Image"
                            savePreview={saveWhitePreview}
                            hasImg={imgUrl}
                          />
                        </div>
                      </Col>

                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Description</label>

                          <div style={styles.editor} onClick={focusEditor}>
                            <Editor
                              // ref={setEditor}
                              // onEditorStateChange={onEditorStateChange}
                              // editorState={editorState}
                              onEditorStateChange={onEditorStateChange}
                              editorState={editorState}
                              handleBeforeInput={handleBeforeInput}
                              toolbar={editorConfig}
                              handlePastedText={() => false}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      {/* {item?.offerType?.offerTypeId === 1 && (
                        <Col className="pr-1" md="6">
                          <div>
                            {" "}
                            <label>Additional Image</label>
                          </div>
                          <img
                            alt="No image"
                            src={item.additionalOfferImage || noImage}
                          />
                        </Col>
                      )} */}

                      {/* {item?.offerType?.offerTypeId === 1 && (
                        <Col className="pr-1 mt-2" md="6">
                          <FormGroup>
                            <label>Is the Campaign Reusable?</label>
                            <Input
                              readOnly
                              defaultValue={item.isReusable ? "Yes" : "No"}
                              placeholder="Reusable"
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      )} */}
                      {/* {item?.offerType?.offerTypeId === 1 && (
                        <Col className="pr-1 mt-2" md="6">
                          <FormGroup>
                            <label>Discount</label>
                            <Input
                              readOnly
                              defaultValue={`$ ${item.discountValue}`}
                              placeholder="Discount"
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      )} */}
                      {/* <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Is it an Event?</label>
                          <Input
                            readOnly
                            defaultValue={item.isEvent ? "Yes" : "No"}
                            placeholder="Reusable"
                            type="text"
                          />
                        </FormGroup>
                      </Col> */}
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <div className="d-flex justify-content-between align-items-center">
                            <label className="mb-0"> Start Date</label>
                          </div>
                          {/* <Input
                            defaultValue={moment(item?.startDate).format(
                              "YYYY-MM-DD",
                            )}
                            disabled
                            style={{ width: "100%", height: "36px" }}
                          /> */}

                          <DatePicker
                            defaultValue={moment()}
                            disabledDate={disableStartDate}
                            style={{ width: "100%", height: "36px" }}
                            value={startDate}
                            onChange={(date) => {
                              setStartDate(date);
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <div className="d-flex justify-content-between align-items-center">
                            <label className="mb-0">End Date</label>
                          </div>
                          <DatePicker
                            defaultValue={moment()}
                            disabledDate={disableEndDate}
                            style={{ width: "100%", height: "36px" }}
                            value={endDate}
                            onChange={(date) => {
                              setEndDate(date);
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Qualifying Purchase</label>
                          <Input
                            readOnly
                            defaultValue={
                              item?.qualifyingPurchase?.title ?? "None"
                            }
                            placeholder="Partner"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Offer</label>
                          <Input
                            readOnly
                            defaultValue={item?.walletOffer?.title ?? "None"}
                            placeholder="Partner"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>User Limit</label>
                          <Input
                            defaultValue={item.userLimit}
                            placeholder="User Limit"
                            type="text"
                            onChange={(event) => {
                              setUserLimit(event.target.value);
                              checkvalidUserLimit(event.target.value);
                            }}
                            onBlur={(event) => {
                              checkvalidUserLimit(event.target.value);
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-1" md="6">
                        <FormGroup>
                          <label
                            style={{ display: "block", marginBottom: "8px" }}
                          >
                            Create User Group
                          </label>
                          <Switch
                            disabled
                            checked={createUserGroup}
                            onChange={(checked) => {
                              setCreateUserGroup(checked);
                            }}
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col className="pr-1" md="6">
                        <FormGroup>
                          <label>Partner Address</label>
                          <Input
                            readOnly
                            defaultValue={item.partnerAddress}
                            placeholder="Location"
                            type="text"
                          />
                        </FormGroup>
                      </Col> */}
                      {/* {item.locations.map((each) => (
                        <Col className="pr-1" md="6">
                          <FormGroup>
                            <label>{each.name}</label>
                            <Input
                              readOnly
                              defaultValue={each.address}
                              placeholder="Location"
                              type="text"
                            />
                          </FormGroup>
                        </Col>
                      ))} */}
                    </Row>

                    {/* <Row>
                      <Col className="pr-1" md="12">
                        <p className="text-[16px]">Campaign Interests:</p>
                        {tagsList?.length > 0 ? tagsList.join(", ") : "None"}
                      </Col>
                    </Row> */}

                    <Row>
                      <Col
                        md="6"
                        className="footer-buttons d-flex justify-content-start mt-4"
                      >
                        <Button
                          onClick={() => props.setPage("1")}
                          color="secondary"
                          size="md"
                          className="btn-round mr-2 cancel-button"
                        >
                          Return{" "}
                        </Button>
                        <Button
                          onClick={continueClick}
                          color="primary"
                          size="md"
                          className="btn-round"
                        >
                          Edit
                        </Button>
                      </Col>
                      <Col md="6"></Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return state.user;
}

export default connect(mapStateToProps, actionCreators, null, {
  forwardRef: true,
})(EditCampaign);
